import { FormControl, InputAdornment } from "@mui/material";
import InputTheme from "../input";
import { LangContext } from "../../../contexts/LangContext";
import { useContext, useState } from "react";
import React from "react";
import CreateIcon from "@mui/icons-material/Create";

export default function InputUserProfile({ errorText, ...props }) {
  const { lang } = useContext(LangContext);

  const [inputActive, setInputActive] = useState(true);

  return (
    <FormControl sx={{ width: "100%", variant: "standard" }}>
      <InputTheme
        InputProps={{
          endAdornment: (
            <InputAdornment position="start">
              <CreateIcon onClick={() => setInputActive(!inputActive)} />
            </InputAdornment>
          ),
        }}
        disabled={inputActive}
        error={props.error}
        helperText={errorText ? "" : errorText}
        label={lang.components.generic.input_user_label}
        id="standard-adornment-user"
        variant="standard"
        type="text"
        InputLabelProps={{
          shrink: true,
        }}
        {...props}
      />
    </FormControl>
  );
}
